export const SHOW_PARAMS = [ "spend", "revenue", "onwRevenue", "totalRevenue", "roi", "factor" ];


// WEBPACK FOOTER //
// ./src/scenes/PayoutFactor/config.js